import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Industries from '../components/Industries';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';

const HomePage = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="homepage">
      <Hero />
      <Products />
      <Features />
      <HowItWorks />
      <Industries />
      <Testimonials />
      <Pricing />
      <Contact />
    </div>
  );
};

export default HomePage;
